import type { ComponentType, SVGProps } from 'react';
import {
  CHANGELOG_PAGE_URL,
  DOCUMENTATION_SITE_URL,
  EXPLORE_API_PATH,
  MCP_EXPLORER_PATH,
  SUPPORT_EMAIL,
  WHATS_NEW_PATH
} from '../../../constants/general';
import { createSupportEmailUrl } from '../../../helpers/link.helper';
import { getTenantName } from '../../../helpers/next.helpers';
import { dedent } from '../../../helpers/string.helper';

export type HelpMenuLink = {
  label: string;
  getHref: () => string;
  external: boolean;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
};

export const RESOURCE_LINKS: HelpMenuLink[] = [
  {
    label: "What's New",
    getHref: () => WHATS_NEW_PATH,
    external: false
  },
  {
    label: 'Documentation',
    getHref: () => DOCUMENTATION_SITE_URL,
    external: true
  },
  {
    label: 'Changelog',
    getHref: () => CHANGELOG_PAGE_URL,
    external: true
  },
  {
    label: 'Status',
    getHref: () => `https://status.${getTenantName()}.moderne.io`,
    external: true
  },
  {
    label: 'Feedback',
    getHref: () =>
      createSupportEmailUrl({
        subject: `[Feedback][${getTenantName()}] - Enter subject`,
        body: dedent(`
              Feedback:
              <-- Need help? Found a bug? Have a suggestion? Let us know! -->

              Screenshots:
              <!-- Include screenshots if applicable.  -->
              `)
      }),
    external: true
  }
];

export const TOOL_LINKS: HelpMenuLink[] = [
  {
    label: 'API explorer',
    getHref: () => EXPLORE_API_PATH,
    external: false
  },
  {
    label: 'MCP explorer',
    getHref: () => MCP_EXPLORER_PATH,
    external: false
  }
];

export const FALLBACK_HELP_LINKS: HelpMenuLink[] = [
  {
    label: SUPPORT_EMAIL,
    getHref: () => `mailto:${SUPPORT_EMAIL}`,
    external: true
  }
];
